var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuperFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.96,9.26l-3,11-.26,.44-1,1-.71,.29H2l-.71-.29-1-1-.29-.71V4l.29-.71,1-1,.71-.29H7l.71,.29,1,1,.29,.71h10l.71,.29,1,1,.29,.71v1h-2v-.59l-.41-.41H7v-1.59l-.41-.41H2.41l-.41,.41v15.17l.06,.06,2.97-10.91,.96-.74H23l.96,1.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuperFolderOpen);
export default __webpack_public_path__ + "static/1769707387/media/icon-super-folder-open.0bbd2a53670db58074a19d98fe102424.svg";
export { ForwardRef as ReactComponent };